export const LOCALES = ['en', 'nb-NO'] as const;
export type Locale = (typeof LOCALES)[number];

/** D29: English is the default UI language. */
export const DEFAULT_LOCALE: Locale = 'en';

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

/** Picks a supported locale from a preference list such as navigator.languages. */
export function negotiateLocale(preferred: readonly string[]): Locale {
  for (const tag of preferred) {
    if (isLocale(tag)) return tag;
    const language = tag.toLowerCase().split('-')[0];
    if (language === 'nb' || language === 'no' || language === 'nn') return 'nb-NO';
    if (language === 'en') return 'en';
  }
  return DEFAULT_LOCALE;
}
